module.exports = __webpack_public_path__ + "static/media/ws.c4eb0596.svg";